import React from "react";
import type { BillLineView } from "../../../interfaces/OrderObject";
import { formatInr } from "../../../services/helpers/MoneyHelper";
import "./Bill.css";

interface BillLinesProps {
  lines: BillLineView[];
  /** Extra charges / discounts, rendered after the lines without a quantity. */
  charges?: BillLineView[];
}

/** The itemised list used by every bill surface. Presentational only. */
const BillLines: React.FC<BillLinesProps> = ({ lines, charges = [] }) => (
  <ul className="bill__lines">
    {[...lines, ...charges].map((line) => (
      <li key={line.key} className="bill__line">
        <span className="bill__name">{line.name}</span>
        <span className="bill__qty">{line.quantity != null ? `×${line.quantity}` : ""}</span>
        <span className="bill__amount">{line.amount != null ? formatInr(line.amount) : "—"}</span>
      </li>
    ))}
  </ul>
);

export default BillLines;
